
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Add event</strong>
          </div>
          <b-form>
            <b-form-group>
              <b-form-input id="eventTitle" 
                        type="text" 
                        autocomplete="name" 
                        v-model="eventData.title" 
                        size="lg" 
                        placeholder="Enter event title...">
              </b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-textarea id="eventDescription"
                        v-model="eventData.description"
                        placeholder="Enter event description..."
                        :rows="3"
                        :max-rows="6"
                        size="sm">
              </b-form-textarea>
            </b-form-group>
            <b-form-group validated
              label="Date" label-for="date"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="date" required id="date" 
              v-model="eventData.date"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Hour" label-for="hour"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="time" required id="hour" 
              v-model="eventData.hour"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Duration (minutes)" label-for="duration"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="number" required id="duration" 
              v-model="eventData.duration"></b-form-input>
            </b-form-group>
            <b-form-group validated
              label="Location" label-for="location"
              :label-cols="3"
              :horizontal="true">
              <gmap-autocomplete
                style="width:100%; height:100%"
                placeholder="Match location..."
                @place_changed="setPlaceLocation">
              </gmap-autocomplete>
            </b-form-group>
            <b-form-group v-if="marker != null"
              label="Extra information" label-for="extraInformation"
              :label-cols="3"
              :horizontal="true">
              <b-form-input type="text" required id="extraInformation" 
              v-model="eventData.location.information"></b-form-input>
            </b-form-group>
            <b-form-group  v-if="marker != null">
              <gmap-map
                :center="center"
                :zoom="15"
                style="width:100%;  height: 400px;">
                <gmap-marker
                  v-model="marker"
                  :position="marker"
                ></gmap-marker>
              </gmap-map>
            </b-form-group>
          <div slot="footer">
            <b-row class="align-items-center">
              <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
              </b-col>
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-if="!isEdit" v-on:click="confirmEventButton" block variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm Event</b-button>
                <b-button type="submit" v-if="isEdit" v-on:click="updateEvent" block variant="primary"><i class="fa fa-dot-circle-o"></i> Save Changes</b-button>
              </b-col>
              <b-col xl= "4" class="mb-3 mb-xl-0" >
                <b-button v-if="isEdit" v-on:click="removeEvent" block variant="danger"><i class="fa fa-ban"></i> Remove Event</b-button>
              </b-col>
            </b-row>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import { auth } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';
export default {
  name: 'forms',
  firebase: {
    events: db.ref('propertyEvents'),
    counts: db.ref('counts')
  },
  data () {
    return {
      isEdit: false,
      eventData: {
        key: null,
        title: null,
        description: null,
        date: null,
        hour: null,
        duration: null,
        location: {
          name: null,
          information: null,
          latitude: null,
          longitude: null
        }
      },
      center: null,
      marker: null,
    }
  },
  created() {
    if(this.$route.params.id){
      this.eventData.key = this.$route.params.id
      this.setEvent()
    }
  },
  methods: {
    setPlaceLocation(place){
      console.log(place)
      //Set match info
      this.eventData.location = {
        name: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }

      //Add marker to map
      this.marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.center = this.marker


    },
    removeEvent(){

      this.$firebaseRefs.events.child(this.eventData.key).remove()

      var countRef = this.$firebaseRefs.counts.child('eventsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          if(count > 0){
            count = count - 1;
          }
        }else{
          count = 0
        }
        return count;
      })

      this.$router.go(-1)
      
    },
    updateEvent(){

      const dateNow = Date.now()

        var eventModel = { 
          timeStamp: new Date( this.eventData.date + " " + this.eventData.hour).getTime(),
          title: this.eventData.title,
          description: this.eventData.description,
          date: this.eventData.date,
          hour: this.eventData.hour,
          duration: this.eventData.duration,
          location: this.eventData.location,
          modified: dateNow
        }

      this.$firebaseRefs.events.child(this.eventData.key).update(eventModel)

      console.log(auth.currentUser.uid)
      db.ref('users/admins').child(auth.currentUser.uid).once('value', (snapshot) => {
        var modifiedByModel = {
          name: snapshot.val().name,
          lastName: snapshot.val().lastName
        }
        
        db.ref('propertyEvents').child(this.eventData.key).child('modifiedBy').child(auth.currentUser.uid).set(modifiedByModel)
      })
      // NEW!!
      // params: type, typeId, typeName, action
      this.notifyAllUsers('event', this.eventData.key, eventModel.title, "modified")

      this.$router.go(-1)
      
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    setEvent(){
      this.isEdit = true
      this.$firebaseRefs.events.child(this.eventData.key).
          once('value', (snap) => {
            this.eventData.title = snap.val().title
            this.eventData.description = snap.val().description
            this.eventData.date = snap.val().date
            this.eventData.hour = snap.val().hour
            this.eventData.duration = snap.val().duration
            this.eventData.location = snap.val().location

            this.marker = {
              lat: snap.val().location.latitude,
              lng: snap.val().location.longitude
            };
            this.center = this.marker

          });
      
    },

    confirmEventButton () {
      this.addEvent()
    },

    addEvent(){
      // console.log("Notifing all users...")
      // this.notifyAllUsers('event', "eventKey", "eventModel.title", "created")
      this.createEventDb();
    },

    // NEW!!
    notifyAllUsers(type, typeId, typeName, action) {  
      const dateNow = Date.now()

      var notificationModel = {
        type: type ,
        typeId: typeId,
        typeName: typeName,
        action: action,
        timestamp: dateNow,
        viewed: false 

      }

      console.log("<-- NOTIFY ALL USERS");
      console.log(notificationModel);
      
        db.ref('users').child('parents').once('value', (snapParents) => {
          db.ref('users').child('coaches').once('value', (snapCoaches) => {
            db.ref('users').child('players').once('value', (snapPlayers) => {
            
            console.log("Notifing coaches..."); 
            snapCoaches.forEach((childSnapshot) => {
              var coachKey = childSnapshot.key;   
              db.ref('userNotifications').child(coachKey).child('notifications').push(notificationModel)
            })  

            console.log("Notifing coaches... ");
            snapPlayers.forEach((childSnapshot) => {
              var playerKey = childSnapshot.key;
              db.ref('userNotifications').child(playerKey).child('notifications').push(notificationModel)
            })

            console.log("Notifing parents...");
            snapParents.forEach((childSnapshot) => {
              var parentKey = childSnapshot.key;
              db.ref('userNotifications').child(parentKey).child('notifications').push(notificationModel)
            })
          })
        })
      })   
    },

    createEventDb(){

      console.log("Creating event on DB...")
      
       
      const dateNow = Date.now()

      var eventModel = { 
        timeStamp: new Date( this.eventData.date + " " + this.eventData.hour).getTime(),
        title: this.eventData.title,
        description: this.eventData.description,
        date: this.eventData.date,
        hour: this.eventData.hour,
        duration: this.eventData.duration,
        location: this.eventData.location,
        created: dateNow,
        modified: dateNow
      }

      var eventKey = this.$firebaseRefs.events.push(eventModel).key

      console.log(auth.currentUser.uid)
      db.ref('users/admins').child(auth.currentUser.uid).once('value', (snapshot) => {
        console.log(snapshot.val().name)

        var createdByModel = {
          name: snapshot.val().name,
          lastName: snapshot.val().lastName
        }

        //Created by
        db.ref('propertyEvents').child(eventKey).child('createdBy').child(auth.currentUser.uid).set(createdByModel)
        db.ref('propertyEvents').child(eventKey).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
        
        //Modified by
        db.ref('propertyEvents').child(eventKey).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
        db.ref('propertyEvents').child(eventKey).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
      })

      // NEW!!
      // params: type, typeId, typeName, action
      this.notifyAllUsers('event', eventKey, eventModel.title, "created")

      var countRef = this.$firebaseRefs.counts.child('eventsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          count = count + 1;
        }else{
          count = 1
        }
        return count;
      })

      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// getAge(birthdate) {
    //   var today = new Date();
    //   var birthDate = new Date(birthdate);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }    
    //   return age;
    // }
    // console.log(this.newUser.birthdate)
      // const timestamp = new Date(this.newUser.birthdate).getTime()
      // console.log(timestamp)
      // const dateFromTimestamp = new Date(timestamp)
      // console.log(dateFromTimestamp)

      // if(this.$route.params.teamid != null){
      //   console.log(this.$route.params.teamid)
      // }else{
      //   console.log("No hay id equipo")
      // }

      // Get a key for a new User.
      // var newUserKey = this.$firebaseRefs.users.push().key;

      // this.$firebaseRefs.users.child(newUserKey).set({
      //    name: this.userName,
      //    category: this.categorySelect
      // })

      // this.$firebaseRefs.users.child().set({
      //   name: this.userName,
      //   category: this.categorySelect
      // })